const ufeApi = require('services/api/ufeApi');

// https://jira.sephora.com/wiki/display/ILLUMINATE/Update+BI+Account+API

function updateBiAccount(input, isOrderConfirmation) {
    const url = isOrderConfirmation ? '/api/bi/account?type=orderConfirmation' : '/api/bi/account';

    return ufeApi
        .makeRequest(url, {
            method: 'PUT',
            body: JSON.stringify(input)
        })
        .then(data => (data.errorCode ? Promise.reject(data) : data));
}

module.exports = updateBiAccount;
